export const SHOWN_MENUS = [
  '/treatments',
  '/contents',
  '/questionnaire',
  '/flows',
];